// Core
import React, { FC, ReactElement, useRef } from 'react';
import Transition, { TransitionStatus } from 'react-transition-group/Transition';

// Styles
import Styles from './styles.module.scss';

// Instruments
import { opacityTransitionConfig } from 'utils/transitionConfig';

type AlwSpinnerProps = {
    className?: string;
    timeout?: number;

    background?: 'primary' | 'secondary';
};

export const AlwSpinner: FC<AlwSpinnerProps> = ({
    className,
    timeout = 0,
    background = 'primary',
}): ReactElement => {
    const nodeRef = useRef(null);

    return (
        <Transition
            in
            appear
            mountOnEnter
            unmountOnExit
            timeout={opacityTransitionConfig(timeout).timeout}
            nodeRef={nodeRef}
        >
            {(state: TransitionStatus) => (
                <div
                    className={[Styles.container, className].filter(Boolean).join(' ')}
                    style={{
                        ...opacityTransitionConfig().defaultStyles,
                        ...opacityTransitionConfig().transitionStyles[state],
                    }}
                >
                    <div
                        className={Styles.inner}
                        style={{
                            background: background === 'primary' ? '#161616' : '#222222',
                        }}
                    />
                </div>
            )}
        </Transition>
    );
};
